import services from './services';
import {
    lg,
    cloneDeep,
    util,
    isCorrectVal,
    isDate
} from 'utils';
import NProgress from 'nprogress';
import chooseDept from "../chooseDept/index.vue";
import addDepartment from "../addDepartment/index.vue";
import $http from '$http';

export default {
    mixins: [services],
    components: {
        chooseDept,
        addDepartment
    },
    props: {},
    created() {},
    data() {
        return {
            AddDialogVisible: false,
            loading: false,
            lists: [],
            ProvList: [{
                ProvId: '',
                CityId: ''
            }],
            isAddBtnShow: [true],
            isDelBtnShow: [false],
            form: this.getSubmitFormData(),
            form2: this.getChangeFormData(),
            CityList: [],
            pageIndex: 1,
            pageSize: 10,
            totalSize: '',
            pageSizes: [10, 20, 50],
            departmentList: []
        }
    },
    methods: {
        getSubmitFormData() {
            return cloneDeep({
                "List": [],
                // "ProvList": [],
                "DataType": 1,
                "CityList": [],
                "BuessionPartId": null
            });
        },
        // 修改提交数据
        getChangeFormData() {
            return cloneDeep({
                "ProvList": [],
                "Id": '',
                "EmployeeId": 0,
                "BuessionPartId": null
            });
        },
        initData() {
            this.form = this.getSubmitFormData()
            this.form2 = this.getChangeFormData()
            this.ProvList = [{
                ProvId: '',
                CityId: ''
            }]
            this.isAddBtnShow = [true]
            this.isDelBtnShow = [false]
            this.pageIndex = 1
        },
        show(opts) {
            this.initData()
            this.AddDialogVisible = true
            this.GetBuessionPartList()
            if (opts.Id !== undefined) {
                // 修改入口
                this.getList(opts.Id)
                this.form2.Id = opts.Id
                this.form2.EmployeeId = opts.CustomerId
            } else {
                // 新增
                this.lists = opts.dataList
            }

        },
        changeProv(index) {
            let ProvinceId = this.ProvList[index].ProvId

            if (ProvinceId !== '') {

                this.GetProvCitys(ProvinceId, index)
            }

        },
        removeList(index) {
            if (index !== -1) {
                this.ProvList.splice(index, 1)
                this.isAddBtnShow.shift(false)
                this.isDelBtnShow.pop(true)
            }
        },
        addList() {
            this.ProvList.push({
                ProvId: '',
                CityId: ''
            });
            this.isDelBtnShow.push(true); //删除按钮
            this.isAddBtnShow.unshift(false); //新增按钮
        },
        // 新增业务部门
        addDepartment() {
            this.$refs.refDepartment.show({})
        },
        addDialogUpdata(item) {
            if (item) {
                if (this.form.BuessionPartId == item.Id) {
                    this.form.BuessionPartId = ''
                }
            }
            this.GetBuessionPartList()
        },
        // 提交
        submit() {
            this.form.List = []
            this.form2.List = []
            var listData = []
            let len = this.lists.length
            for (let i = 0; i < len; i++) {
                this.form.List.push({
                    'EmployeeId': this.lists[i].ID
                })
            }
            let len2 = this.ProvList.length
            for (let i = 0; i < len2; i++) {
                if (this.ProvList[i].ProvId !== '') {
                    listData.push({
                        ProvId: this.ProvList[i].ProvId,
                        CityId: this.ProvList[i].CityId
                    })
                    //this.form.ProvList.push(this.ProvList[i].ProvincesId)
                }

            }


            if (listData.length == 0) {
                this.$notify({
                    title: '警告',
                    message: '选择所属区域！',
                    type: 'warning'
                });
                return;
            }
            if (this.form.BuessionPartId == 0 || this.form.BuessionPartId == null) {
                this.$notify({
                    title: '警告',
                    message: '请选择业务员所属业务部门！',
                    type: 'warning'
                });
                return;
            }
            if (this.form2.Id !== '') {
                // 修改
                this.form2.CityList = cloneDeep(listData)
                this.ModifyAgentEmployee()
            } else {
                // 新增
                this.form.CityList = cloneDeep(listData)
                this.AddAgentEmployee()
            }

        },
        //取消
        close() {
            this.AddDialogVisible = false
        }

    },
    computed: {
        //省下拉列表
        provinceList() {
            return this.$store.state.allProvince
        }
    },
}


// WEBPACK FOOTER //
// ./src/pages/Agent/AddEmployee/components/setEmployeeArea/vm.js